import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      user: null,
      isLoading: false,
      token: Cookies.get('token'),
      expiresToken: Cookies.get('expiresToken'),
      BGGList: [],
      isNavigating: false,
      appLanguage: Cookies.get('app-language'),
  },
  mutations: {
    saveAppLanguage (state, { appLanguage }) {
        state.appLanguage = appLanguage;
        Cookies.set('app-language', appLanguage, { expires: 365 })
    },

    savetoken (state, { token, remember }) {
        state.token = token;
        Cookies.set('token', token, { expires: remember ? 365 : null });
    },

    saveExpiresToken (state, { expiresToken, remember }) {
        state.expiresToken = expiresToken;
        var dt = new Date();
        dt.setSeconds( dt.getSeconds() + expiresToken );
        var milisecs = dt.getTime();
        Cookies.set('expiresToken', milisecs, { expires: remember ? 365 : null })
    },

    saveIsNavigating (state, { isNavigating }) {
        state.isNavigating = isNavigating;
    },

    saveUser (state, { user }) {
        state.user = user;
    },

    saveBGGList (state, { BGGList }) {
        state.BGGList = BGGList;
    },

    saveIsLoading (state, { isLoading }) {
        state.isLoading = isLoading;
    },

    forceLogout (state) {
        state.user = null;
        state.token = null;
        state.expiresToken = null;
        state.BGGList = [];
        Cookies.remove('token');
        Cookies.remove('expiresToken');
    }
  },
  actions: {
        saveAppLanguage ({ commit, dispatch }, payload) {
            commit('saveAppLanguage', payload)
        },

        saveToken ({ commit, dispatch }, payload) {
            commit('savetoken', payload)
        },

        saveExpiresToken ({ commit, dispatch }, payload) {
            commit('saveExpiresToken', payload)
        },

        saveUser ({ commit, dispatch }, payload) {
            commit('saveUser', payload)
        },

        saveIsNavigating ({ commit, dispatch }, payload) {
            commit('saveIsNavigating', payload)
        },

        saveBGGList ({ commit, dispatch }, payload) {
            commit('saveBGGList', payload)
        },

        saveIsLoading ({ commit, dispatch }, payload) {
            commit('saveIsLoading', payload)
        },

        forceLogout ({ commit, dispatch }) {
            commit('forceLogout')
        }
  },
  getters: {
    user: state => state.user,
    isNavigating: state => state.isNavigating,
    token: state => state.token,
    expiresToken: state => state.expiresToken,
    isLoading: state => state.isLoading,
    BGGList: state => state.BGGList,
    appLanguage: state => state.appLanguage,
  }
});
